import { EmailSubscriptionConsentForm, EmailSubscriptionConsentFormProps, EmailSubscriptionConsentFormState } from '../Views/EmailSubscriptionConsentForm';
import { EmailSubscriptionInfo, EmailSubscriptionClient, UserAgreementConsentInfo, UserAgreementConsentVersion } from '../Generated/RestClient';
import { MessageBox } from '../Dialogs/MessageBox';
import { clientAppSettings } from '../Models/ClientAppSettings';
import { resourceStrings } from "../../../Intercom.ReactUI/Views/Strings";
import { InputDialogBase } from '../Dialogs/InputDialogBase';
import isInFrame from "../../../Intercom.ReactUI/Utils/InFrame";

/**
 * Email subscription dialog class
 */
class EmailSubscriptionDialog extends InputDialogBase<EmailSubscriptionConsentFormProps, EmailSubscriptionConsentFormState> {
    private isShown: boolean;

    protected panel: EmailSubscriptionConsentForm;

    get visible(): boolean {
        return this.isShown;
    }
    
    constructor(props: EmailSubscriptionConsentFormProps) {
        super(EmailSubscriptionConsentForm, props);
    }

    public showDialog(): JQueryPromise<any> {
        this.isShown = true;
        return super.showDialog();
    }

    public closeDialog(): void {
        this.isShown = false;
        super.closeDialog();
    }
}

/**
 * Email subscription consent conductor 
 */
export class EmailSubscriptionConsentConductor {
    public static UserHasConsented(info: EmailSubscriptionInfo): boolean {
        if (info.Subscription && info.Subscription.HasConsent) {
            return true;
        }

        return false;
    }

    public static UserHasAgreed(info: UserAgreementConsentInfo): boolean {
        if (!info || info.ConsentVersion < UserAgreementConsentVersion.V2) {
            return false;
        }

        return true;
    }

    private dialog: EmailSubscriptionDialog;

    private get allowShowDialog(): boolean {
        // Don't show the dialog if the system is loaded in Azure iframe
        if (isInFrame()) {
            return false;
        }

        // If user has not consented or the dialog is not visible
        if (clientAppSettings.hasCollectedConsent || (this.dialog && this.dialog.visible)) {
            return false;
        }

        return true;
    }

    private onSave = (updated: EmailSubscriptionInfo) => {
        this.dialog.closeDialog();

        EmailSubscriptionClient.updateAgreement(true)
            .fail(xhr => {
                MessageBox.show(resourceStrings.subscriptionConsentDialog.updateErrorMessage);
            });
    }

    private onCancel = () => {
        this.dialog.closeDialog();
    }

    private onUserAgreementLoaded = (info: UserAgreementConsentInfo) => {
        if (EmailSubscriptionConsentConductor.UserHasAgreed(info)) {
            return;
        }

        if (!this.dialog) {
            this.dialog = new EmailSubscriptionDialog({
                subscriptionInfo: null,
                askUserAgreement: true,
                onSave: this.onSave,
                onCancel: this.onCancel
            } as EmailSubscriptionConsentFormProps);
        }

        this.dialog.showDialog();
    }

    public showIfRequired() {
        if (!this.allowShowDialog) {
            return;
        }

        clientAppSettings.hasCollectedConsent = true;

        EmailSubscriptionClient.getUserAgreement()
                               .then(this.onUserAgreementLoaded)
                               .fail(xhr => clientAppSettings.hasCollectedConsent = false);
    }
}


// WEBPACK FOOTER //
// ./Client/Controllers/EmailSubscriptionConsent.ts